<div class="edit-hero">
    <div class="container">
        <div class="row align-items-center">
            <div class="col-md-6">
                <button class="btn btn-back" (click)="goBack()">
                    <i class="bi bi-arrow-left-circle-fill"></i>
                    <span>Back to Joint Rules</span>
                </button>
            </div>
            <div class="col-md-6 text-end">
                <button type="button" class="btn btn-hero-action" (click)="showJointSectionInformation()">
                    <i class="bi bi-plus-circle-fill"></i>
                    <span>Add Joint Section</span>
                </button>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <div class="hero-content">
                    <h1 class="hero-title">
                        <i class="bi bi-bezier2 hero-icon"></i>
                        Edit Joint Rule
                    </h1>
                    <p class="hero-subtitle">View and edit joint rule information and joint sections</p>
                </div>
            </div>
        </div>
    </div>
</div>

<div class="container edit-container">


        <!-- Loading indicator -->
        <div *ngIf="loading" class="loader-overlay">
            <div class="spinner-wrapper">
                <div class="spinner-border text-light" role="status"></div>
                <p class="loading-text">Loading rule details...</p>
            </div>
        </div>

        <!-- Rule Information -->
        <div class="row" *ngIf="!loading && rule">
            <!-- Rule Details Card -->
            <div class="col-md-12 mb-4">
                <div class="modern-info-card">
                    <div class="info-card-header">
                        <div class="header-content">
                            <i class="bi bi-info-circle-fill header-icon"></i>
                            <h5 class="header-title">Rule Information</h5>
                        </div>
                    </div>
                    <div class="info-card-body">
                        <div class="row">
                            <div class="col-md-6">
                                <dl class="row">
                                    <dt class="col-sm-4">Rule ID:</dt>
                                    <dd class="col-sm-8">{{rule.id || 'N/A'}}</dd>

                                    <dt class="col-sm-4">Rule Name:</dt>
                                    <dd class="col-sm-8">{{rule.name || 'N/A'}}</dd>

                                    <dt class="col-sm-4">Rule Description:</dt>
                                    <dd class="col-sm-8">{{rule.description || 'N/A'}}</dd>

                                </dl>
                            </div>
                            <div class="col-md-6">
                                <dl class="row">
                                    <dt class="col-sm-4">Created At:</dt>
                                    <dd class="col-sm-8">
                                        <span *ngIf="rule.createdAt">{{rule.createdAt | date:'short'}}</span>
                                        <span *ngIf="!rule.createdAt">N/A</span>
                                    </dd>

                                    <dt class="col-sm-4">Updated At:</dt>
                                    <dd class="col-sm-8">
                                        <span *ngIf="rule.updatedAt">{{rule.updatedAt | date:'short'}}</span>
                                        <span *ngIf="!rule.updatedAt">N/A</span>
                                    </dd>

                                    <dt class="col-sm-4">Joint Sections Count:</dt>
                                    <dd class="col-sm-8">
                                        <span class="modern-badge badge-primary">{{rule.jointSections.length || 0}}</span>
                                    </dd>

                                    <dt class="col-sm-4">Polyline:</dt>
                                    <dd class="col-sm-8">
                                        <span *ngIf="rule.polyline" class="modern-badge badge-success">
                                            Segments: {{rule.polyline.segmentCount}}, Nodes: {{rule.polyline.nodeCount}}
                                        </span>
                                        <span *ngIf="!rule.polyline" class="badge bg-secondary">No Polyline</span>
                                        <button
                                            class="btn-modern-action btn-action-secondary ms-2"
                                            (click)="showPolylineInformation()"
                                            >
                                            <i class="bi bi-pencil-fill" *ngIf="rule.polyline"></i>
                                            <i class="bi bi-pencil" *ngIf="!rule.polyline"></i>
                                        </button>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Sections Card -->
            <div class="col-md-12 mb-4" *ngIf="rule.jointSections && rule.jointSections.length > 0">
                <div class="modern-sections-card">
                    <div class="sections-card-header">
                        <div class="header-content">
                            <i class="bi bi-diagram-3-fill header-icon"></i>
                            <h5 class="header-title">Joint Sections</h5>
                        </div>
                        <span class="section-count-badge">{{rule.jointSections.length}}</span>
                    </div>
                    <div class="sections-card-body">
                        <div class="accordion" id="sectionsAccordion">
                            <div class="accordion-item"
                                *ngFor="let section of rule.jointSections; let i = index; trackBy: trackBySectionId">
                                
                                <div [id]="'collapse' + i" class="accordion-collapse collapse" [class.show]="i === 0"
                                    [attr.aria-labelledby]="'heading' + i" data-bs-parent="#sectionsAccordion">
                                    <div class="accordion-body">
                                        <!-- Joint Sections -->
                                        <div *ngIf="hasJointSections(rule)">
                                            <h6 class="section-subtitle">
                                                <i class="bi bi-layers-fill"></i> Joint Sections
                                            </h6>
                                            <div class="modern-table-wrapper">
                                                <table class="modern-edit-table">
                                                    <thead>
                                                        <tr>
                                                            <th (click)="onSort('id')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('id')"></i>
                                                                ID
                                                            </th>
                                                            <th (click)="onSort('description')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('description')"></i>
                                                                Description
                                                            </th>
                                                            <th (click)="onSort('material')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('material')"></i>
                                                                Material
                                                            </th>
                                                            <th (click)="onSort('type')" class="sortable-header">
                                                                <i class="bi sort-icon" [ngClass]="getSortIcon('type')"></i>
                                                                Type
                                                            </th>
                                                            <th>Article IDs</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr
                                                            *ngFor="let jointSection of rule.jointSections; trackBy: trackByJointSectionId">
                                                            <td class="id-cell">{{jointSection.id || 'N/A'}}
                                                            </td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === jointSection.id + '-description'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="jointSection.description"
                                                                    (blur)="stopEditing(jointSection)" autofocus />

                                                                <span
                                                                    *ngIf="editingField !== jointSection.id + '-description'"
                                                                    (click)="startEditing(jointSection, 'description')"
                                                                    class="editable-text">
                                                                    {{ jointSection.description || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === jointSection.id + '-material'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="jointSection.material"
                                                                    (blur)="stopEditing(jointSection)" autofocus />
                                                                <span
                                                                    *ngIf="editingField !== jointSection.id + '-material'"
                                                                    (click)="startEditing(jointSection, 'material')"
                                                                    class="badge bg-secondary editable-text">
                                                                    {{ jointSection.material || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    *ngIf="editingField === jointSection.id + '-type'"
                                                                    type="text" class="form-control form-control-sm"
                                                                    [(ngModel)]="jointSection.type"
                                                                    (blur)="stopEditing(jointSection)" autofocus />
                                                                <span *ngIf="editingField !== jointSection.id + '-type'"
                                                                    (click)="startEditing(jointSection, 'type')"
                                                                    class="badge bg-info editable-text">
                                                                    {{ jointSection.type || 'N/A' }}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <div class="d-flex align-items-center gap-2">
                                                                    <span
                                                                        *ngIf="jointSection?.articleIds?.length; else none">
                                                                        <span class="badge bg-primary me-1"
                                                                            *ngFor="let article of jointSection.articleIds">
                                                                            {{ article }}
                                                                        </span>
                                                                    </span>

                                                                    <ng-template #none>
                                                                        <span class="text-muted">None</span>
                                                                    </ng-template>                                                                    
                                                                    <button class="btn-modern-action btn-action-secondary"
                                                                        *ngIf="jointSection.articleIds"
                                                                        (click)="showArticleInformation(jointSection)">
                                                                        <i class="bi bi-pencil-fill"></i>
                                                                    </button>
                                                                </div>
                                                            </td>
                                                           
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        <div *ngIf="!hasJointSections(rule)" class="alert alert-info">
                                            <i class="bi bi-info-circle"></i> No joint sections available for this
                                            section.
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- No Sections Message -->
            <div class="col-md-12" *ngIf="!rule.jointSections || rule.jointSections.length === 0">
                <div class="alert alert-warning">
                    <i class="bi bi-exclamation-triangle"></i> No sections available for this rule.
                </div>
            </div>
        </div>
    </div>





    <!-- Article Modal -->
    <div class="modal fade" [class.show]="showArticleModal" [style.display]="showArticleModal ? 'block' : 'none'"
        tabindex="-1" *ngIf="showArticleModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modern-modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-journal-text me-2"></i>
                        Article Data
                    </h5>
                    <button type="button" class="btn-close btn-close-dark" (click)="closeArticleModal()" 
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <!-- Article Section -->
                    <div class="article-section">
                        <!-- Header row: Title + Add Button -->
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="text-muted mb-0"><i class="bi bi-list-ul me-2"></i> Articles</h6>
                            <button class="btn-modern-action btn-action-primary" (click)="addArticle()">
                                <i class="bi bi-plus-circle me-1"></i>
                                Add Article
                            </button>
                        </div>

                        <!-- No Articles Message -->
                        <div *ngIf="articles.length === 0 && !isAddingArticle" class="alert alert-info mb-0">
                            <i class="bi bi-info-circle me-2"></i>
                            No articles added. Click <strong>Add Article</strong> to get started.
                        </div>

                        <div class="modern-table-wrapper" *ngIf="articles.length > 0 || isAddingArticle">
                            <table class="modern-edit-table">
                                <thead>
                                    <tr>
                                        <th><i class="bi bi-hash me-1"></i> Article ID</th>
                                        <th><i class="bi bi-tag me-1"></i> Article Name</th>
                                        <th><i class="bi bi-palette me-1"></i> Material</th>
                                        <th><i class="bi bi-diagram-3 me-1"></i> Type</th>
                                        <th style="width: 80px;"><i class="bi bi-gear"></i></th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <!-- Add Article Row -->
                                    <tr *ngIf="isAddingArticle" class="adding-row">
                                        <td><span class="badge bg-success">New</span></td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.articleName" 
                                                class="form-control modern-input" placeholder="Enter article name" />
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.material" 
                                                class="form-control modern-input" placeholder="Enter material" />
                                        </td>
                                        <td>
                                            <input type="text" [(ngModel)]="newArticle.type" 
                                                class="form-control modern-input" placeholder="Enter type" />
                                        </td>
                                        <td>
                                            <button class="btn btn-sm btn-success me-1" (click)="saveNewArticle()" 
                                                title="Save">
                                                <i class="bi bi-check-lg"></i>
                                            </button>
                                                <button class="btn btn-sm btn-secondary"
                                                (click)="cancelAddArticle()" title="Cancel">
                                                <i class="bi bi-x-lg"></i>
                                            </button>
                                    </td>
                                </tr>

                                    <!-- Existing Articles -->
                                    <tr *ngFor="let art of articles; let i = index">
                                        <td>{{ art.id }}<span class="badge bg-primary"></span></td>

                                        <!-- Article Name -->
                                        <td>
                                            <input *ngIf="editingField === 'art-' + i + '-articleName'" type="text"
                                                class="form-control modern-input" [(ngModel)]="art.articleName"
                                            (blur)="stopEditingArticle(i, 'articleName')" autofocus />
                                        <span *ngIf="editingField !== 'art-' + i + '-articleName'"
                                            (click)="startEditingArticle(i, 'articleName')" class="editable-text">
                                            {{ art.articleName || 'N/A' }}
                                        </span>
                                    </td>

                                    <!-- Material -->
                                    <td>
                                        <input *ngIf="editingField === 'art-' + i + '-material'" type="text"
                                            class="form-control modern-input" [(ngModel)]="art.material"
                                            (blur)="stopEditingArticle(i, 'material')" autofocus />
                                        <span *ngIf="editingField !== 'art-' + i + '-material'"
                                            (click)="startEditingArticle(i, 'material')" class="editable-text">
                                            {{ art.material || 'N/A' }}
                                        </span>
                                    </td>

                                    <!-- Type -->
                                    <td>
                                        <input *ngIf="editingField === 'art-' + i + '-type'" type="text"
                                                class="form-control modern-input" [(ngModel)]="art.type"
                                                (blur)="stopEditingArticle(i, 'type')" autofocus />
                                            <span *ngIf="editingField !== 'art-' + i + '-type'"
                                                (click)="startEditingArticle(i, 'type')" class="editable-text">
                                                {{ art.type || 'N/A' }}
                                            </span>
                                        </td>

                                        <td>
                                            <button type="button" class="btn btn-sm btn-danger"
                                                (click)="removeArticle(i)" title="Remove Article">
                                                <i class="bi bi-trash"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeArticleModal()">
                        <i class="bi bi-x-circle me-1"></i>
                        Close
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showArticleModal" *ngIf="showArticleModal"></div>

    <!-- Cross Section Modal -->
    <div class="modal fade" [class.show]="showJointSectionModal"
        [style.display]="showJointSectionModal ? 'block' : 'none'" tabindex="-1" *ngIf="showJointSectionModal">
        <div class="modal-dialog modal-lg">
            <div class="modal-content">
                <div class="modal-header modern-modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-diagram-3 me-2"></i>
                        Joint Section Details
                    </h5>
                    <button type="button" class="btn-close btn-close-dark" (click)="closeJointSectionModal()"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div *ngIf="currentJointSection">
                        <!-- Basic Information -->
                        <div class="modern-section-card mb-3">
                            <div class="section-card-header">
                                <div class="header-content">
                                    <i class="bi bi-info-circle header-icon"></i>
                                    <h6 class="header-title">Basic Information</h6>
                                </div>
                            </div>
                            <div class="section-card-body">
                                <div class="row g-3">
                                    <div class="col-md-4">
                                        <div class="form-group-modern">
                                            <label class="form-label-modern">
                                                <i class="bi bi-card-text"></i>
                                                Description *
                                            </label>
                                            <input type="text" class="form-control-modern"
                                                [(ngModel)]="currentJointSection!.description" 
                                                placeholder="Enter section description"
                                                name="description">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group-modern">
                                            <label class="form-label-modern">
                                                <i class="bi bi-box"></i>
                                                Material *
                                            </label>
                                            <input type="text" class="form-control-modern" 
                                                [(ngModel)]="currentJointSection!.material"
                                                placeholder="e.g., Aluminum, Steel"
                                                name="material">
                                        </div>
                                    </div>
                                    <div class="col-md-4">
                                        <div class="form-group-modern">
                                            <label class="form-label-modern">
                                                <i class="bi bi-tag"></i>
                                                Type *
                                            </label>
                                            <input type="text" class="form-control-modern" 
                                                [(ngModel)]="currentJointSection!.type"
                                                placeholder="Section type"
                                                name="type">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Additional Data -->
                        <div class="modern-section-card">
                            <div class="section-card-header">
                                <div class="header-content">
                                    <i class="bi bi-collection header-icon"></i>
                                    <h6 class="header-title">Additional Data</h6>
                                </div>
                            </div>
                            <div class="section-card-body">
                                <div class="row g-3">
                                    <div class="col-md-6">
                                        <div class="form-group-modern">
                                            <label class="form-label-modern">
                                                <i class="bi bi-list-ul"></i>
                                                Articles (JSON)
                                            </label>
                                            <input type="text" class="form-control-modern" 
                                                [(ngModel)]="articles"
                                                placeholder='[{"id":"ART-001","qty":2}]'
                                                name="articles">
                                            <small class="text-muted">Enter articles in JSON format</small>
                                        </div>
                                    </div>
                                    <div class="col-md-6">
                                        <div class="form-group-modern">
                                            <label class="form-label-modern">
                                                <i class="bi bi-image"></i>
                                                Image URL
                                            </label>
                                            <input type="url" class="form-control-modern" 
                                                [(ngModel)]="imageUrl"
                                                placeholder="https://example.com/image.jpg"
                                                name="imageUrl">
                                            <small class="text-muted">Optional reference image</small>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" (click)="closeJointSectionModal()">
                        <i class="bi bi-x-circle me-1"></i>
                        Cancel
                    </button>
                    <button type="button" class="btn btn-primary" [disabled]="!isJointSectionValid()"
                        (click)="saveJointSection()">
                        <i class="bi bi-check-circle me-1"></i>
                        Save Section
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showJointSectionModal" *ngIf="showJointSectionModal"></div>

    <!-- Polyline Modal -->
    <div class="modal fade" [class.show]="showPolylineModal"
        [style.display]="showPolylineModal ? 'block' : 'none'" tabindex="-1" *ngIf="showPolylineModal">
        <div class="modal-dialog modal-xl">
            <div class="modal-content">
                <div class="modal-header modern-modal-header">
                    <h5 class="modal-title">
                        <i class="bi bi-bezier2 me-2"></i>
                        Polyline Details
                    </h5>
                    <button type="button" class="btn-close btn-close-dark" (click)="closePolylineModal()"
                        aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div *ngIf="currentPolyline">
                        <!-- Summary Information -->
                        <div class="row mb-4">
                            <div class="col-md-3">
                                <div class="modern-stat-card">
                                    <div class="stat-icon-wrapper">
                                        <i class="bi bi-rulers"></i>
                                    </div>
                                    <div class="stat-content">
                                        <label class="stat-label">Total Length</label>
                                        <div class="stat-value">{{currentPolyline.totalLength | number:'1.2-2'}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="modern-stat-card">
                                    <div class="stat-icon-wrapper">
                                        <i class="bi bi-diagram-3"></i>
                                    </div>
                                    <div class="stat-content">
                                        <label class="stat-label">Segment Count</label>
                                        <div class="stat-value">{{currentPolyline.segmentCount}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="modern-stat-card">
                                    <div class="stat-icon-wrapper">
                                        <i class="bi bi-record-circle"></i>
                                    </div>
                                    <div class="stat-content">
                                        <label class="stat-label">Node Count</label>
                                        <div class="stat-value">{{currentPolyline.nodeCount}}</div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="modern-stat-card">
                                    <div class="stat-icon-wrapper">
                                        <i class="bi bi-arrow-repeat"></i>
                                    </div>
                                    <div class="stat-content">
                                        <label class="stat-label">Is Closed</label>
                                        <div class="stat-value">
                                            <span class="modern-badge" [ngClass]="currentPolyline.isClosed ? 'badge-success' : 'badge-secondary'">
                                                {{currentPolyline.isClosed ? 'True' : 'False'}}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Segments Section -->
                        <div class="modern-section-card mb-4">
                            <div class="section-card-header">
                                <div class="header-content">
                                    <i class="bi bi-bezier2 header-icon"></i>
                                    <h6 class="header-title">Segments</h6>
                                </div>
                                <button class="btn-modern-action btn-action-primary" (click)="addSegment()" *ngIf="!isAddingSegment">
                                    <i class="bi bi-plus-circle-fill"></i>
                                    <span>Add Segment</span>
                                </button>
                            </div>
                            <div class="section-card-body">

                                <div class="modern-table-wrapper" style="max-height: 300px; overflow-y: auto;">
                                    <table class="modern-table">
                                        <thead>
                                        <tr>
                                            <th>Start X</th>
                                            <th>Start Y</th>
                                            <th>End X</th>
                                            <th>End Y</th>
                                            <th>Length</th>
                                            <th style="width:60px;"></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- Add Segment Row -->
                                        <tr *ngIf="isAddingSegment" class="table-row-editing">
                                            <td><input type="number" [(ngModel)]="newSegment.startPoint.x" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="X" /></td>
                                            <td><input type="number" [(ngModel)]="newSegment.startPoint.y" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="Y" /></td>
                                            <td><input type="number" [(ngModel)]="newSegment.endPoint.x" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="X" /></td>
                                            <td><input type="number" [(ngModel)]="newSegment.endPoint.y" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="Y" /></td>
                                            <td><span class="text-muted">Auto-calculated</span></td>
                                            <td>
                                                <div class="btn-group-modern">
                                                    <button class="btn-modern-action btn-action-success" (click)="saveNewSegment()">
                                                        <i class="bi bi-check-circle-fill"></i>
                                                    </button>
                                                    <button class="btn-modern-action btn-action-secondary" (click)="cancelAddSegment()">
                                                        <i class="bi bi-x-circle-fill"></i>
                                                    </button>
                                                </div>
                                            </td>
                                        </tr>

                                        <!-- Existing Segments -->
                                        <tr *ngFor="let segment of currentPolyline.segments; let i = index" class="table-row-hover">
                                            <td><input type="number" [(ngModel)]="segment.startPoint.x" (ngModelChange)="updateSegmentLength(i)" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" /></td>
                                            <td><input type="number" [(ngModel)]="segment.startPoint.y" (ngModelChange)="updateSegmentLength(i)" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" /></td>
                                            <td><input type="number" [(ngModel)]="segment.endPoint.x" (ngModelChange)="updateSegmentLength(i)" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" /></td>
                                            <td><input type="number" [(ngModel)]="segment.endPoint.y" (ngModelChange)="updateSegmentLength(i)" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" /></td>
                                            <td><span class="modern-badge badge-primary">{{segment.length | number:'1.2-2'}}</span></td>
                                            <td>
                                                <button type="button" class="btn-modern-action btn-action-danger-secondary" (click)="removeSegment(i)">
                                                    <i class="bi bi-trash-fill"></i>
                                                </button>
                                            </td>
                                        </tr>

                                        <tr *ngIf="!currentPolyline.segments || currentPolyline.segments.length === 0 && !isAddingSegment">
                                            <td colspan="6" class="text-center text-muted py-4">
                                                <i class="bi bi-inbox me-2"></i>
                                                No segments. Click "Add Segment" to add one.
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>

                        <div class="row">
                            <div class="col-md-6">
                                <!-- Polyline Visualization -->
                                <div class="modern-section-card mb-4">
                                    <div class="section-card-header">
                                        <div class="header-content">
                                            <i class="bi bi-eye header-icon"></i>
                                            <h6 class="header-title">Polyline Preview</h6>
                                        </div>
                                        <button class="btn-modern-action btn-action-primary">
                                            <span>Nodes: {{currentPolyline.segments.length}}</span>
                                        </button>
                                    </div>
                                    <div class="section-card-body" style="margin: -15px;">
                                        <div class="polyline-preview-canvas">
                                            <svg width="100%" height="100%" viewBox="0 0 400 220" preserveAspectRatio="xMidYMid meet" 
                                                style="border: 1px dashed #dee2e6;">
                                                <!-- Grid lines -->
                                                <defs>
                                                    <pattern id="grid" width="20" height="20" patternUnits="userSpaceOnUse">
                                                        <path d="M 20 0 L 0 0 0 20" fill="none" stroke="#e9ecef" stroke-width="0.5"/>
                                                    </pattern>
                                                </defs>
                                                <rect width="100%" height="100%" fill="url(#grid)" />
                                                
                                                <!-- Axis indicators -->
                                                <g *ngIf="currentPolyline?.segments && currentPolyline.segments.length > 0">
                                                    <!-- X-axis label -->
                                                    <text x="380" y="215" font-size="11" fill="#495057" font-weight="bold">X →</text>
                                                    <!-- Y-axis label -->
                                                    <text x="10" y="15" font-size="11" fill="#495057" font-weight="bold">↑ Y</text>
                                                </g>
                                                
                                                <!-- Polyline segments -->
                                                <g *ngIf="currentPolyline?.segments && currentPolyline.segments.length > 0">
                                                    <line *ngFor="let segment of currentPolyline.segments; let i = index"
                                                        [attr.x1]="svgScaleX(segment.startPoint.x)"
                                                        [attr.y1]="svgScaleY(segment.startPoint.y)"
                                                        [attr.x2]="svgScaleX(segment.endPoint.x)"
                                                        [attr.y2]="svgScaleY(segment.endPoint.y)"
                                                        stroke="#0d6efd"
                                                        stroke-width="2"
                                                        stroke-linecap="round" />
                                                </g>
                                                
                                                <!-- Nodes -->
                                                <g *ngIf="currentPolyline?.nodes && currentPolyline.nodes.length > 0">
                                                    <circle *ngFor="let node of currentPolyline.nodes; let i = index"
                                                        [attr.cx]="svgScaleX(node.point.x)"
                                                        [attr.cy]="svgScaleY(node.point.y)"
                                                        r="4"
                                                        [attr.fill]="i === 0 ? '#198754' : (i === currentPolyline.nodes.length - 1 && !currentPolyline.isClosed ? '#dc3545' : '#0d6efd')"
                                                        stroke="white"
                                                        stroke-width="1.5" />
                                                    
                                                    <!-- Node labels -->
                                                    <text *ngFor="let node of currentPolyline.nodes; let i = index"
                                                        [attr.x]="svgScaleX(node.point.x) + 8"
                                                        [attr.y]="svgScaleY(node.point.y) - 8"
                                                        font-size="10"
                                                        fill="#495057">
                                                        N{{i}}
                                                    </text>
                                                </g>
                                                
                                                <!-- Legend inside SVG -->
                                                <g *ngIf="currentPolyline?.nodes && currentPolyline.nodes.length > 0">
                                                    <!-- Legend background -->
                                                    <rect x="10" y="200" width="140" height="18" fill="white" stroke="#dee2e6" stroke-width="1" rx="3"/>
                                                    
                                                    <!-- Start node -->
                                                    <circle cx="18" cy="209" r="4" fill="#198754" stroke="white" stroke-width="1.5"/>
                                                    <text x="26" y="212" font-size="9" fill="#495057">Start</text>
                                                    
                                                    <!-- End node -->
                                                    <circle cx="62" cy="209" r="4" fill="#dc3545" stroke="white" stroke-width="1.5"/>
                                                    <text x="70" y="212" font-size="9" fill="#495057">End</text>
                                                    
                                                    <!-- Middle nodes -->
                                                    <circle cx="105" cy="209" r="4" fill="#0d6efd" stroke="white" stroke-width="1.5"/>
                                                    <text x="113" y="212" font-size="9" fill="#495057">Middle</text>
                                                </g>
                                                
                                                <!-- Message when no data -->
                                                <text *ngIf="!currentPolyline?.segments || currentPolyline.segments.length === 0"
                                                    x="200" y="110" text-anchor="middle" fill="#6c757d" font-size="14">
                                                    Add segments to see polyline preview
                                                </text>
                                            </svg>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <!-- Nodes Section -->
                                <div class="modern-section-card mb-4">
                                    <div class="section-card-header">
                                        <div class="header-content">
                                            <i class="bi bi-record-circle header-icon"></i>
                                            <h6 class="header-title">Nodes</h6>
                                        </div>
                                        <button class="btn-modern-action btn-action-primary" (click)="addNode()" *ngIf="!isAddingNode">
                                            <i class="bi bi-plus-circle-fill"></i>
                                            <span>Add Node</span>
                                        </button>
                                    </div>
                                    <div class="section-card-body">
                                        <div class="modern-table-wrapper" style="max-height: 300px; overflow-y: auto;">
                                            <table class="modern-table">
                                                <thead>
                                                    <tr>
                                                        <th>Index</th>
                                                        <th>X</th>
                                                        <th>Y</th>
                                                        <th style="width:60px;"></th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <!-- Add Node Row -->
                                                    <tr *ngIf="isAddingNode" class="table-row-editing">
                                                        <td>{{newNode.index}}</td>
                                                        <td><input type="number" [(ngModel)]="newNode.point.x" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="X" /></td>
                                                        <td><input type="number" [(ngModel)]="newNode.point.y" class="form-control form-control-sm ng-untouched ng-pristine ng-valid" placeholder="Y" /></td>
                                                        <td>
                                                            <div class="btn-group-modern">
                                                                <button class="btn-modern-action btn-action-success" (click)="saveNewNode()">
                                                                    <i class="bi bi-check-circle-fill"></i>
                                                                </button>
                                                                <button class="btn-modern-action btn-action-secondary" (click)="cancelAddNode()">
                                                                    <i class="bi bi-x-circle-fill"></i>
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>

                                                    <!-- Existing Nodes -->
                                                    <tr *ngFor="let node of currentPolyline.nodes; let i = index" class="table-row-hover">
                                                        <td>{{node.index}}</td>
                                                        <td>{{node.point.x}}</td>
                                                        <td>{{node.point.y}}</td>
                                                        <td>
                                                            <button type="button" class="btn-modern-action btn-action-danger-secondary" (click)="removeNode(i)">
                                                                <i class="bi bi-trash-fill"></i>
                                                            </button>
                                                        </td>
                                                    </tr>

                                                    <tr *ngIf="!currentPolyline.nodes || currentPolyline.nodes.length === 0 && !isAddingNode">
                                                        <td colspan="4" class="text-center text-muted py-4">
                                                            <i class="bi bi-inbox me-2"></i>
                                                            No nodes. Click "Add Node" to add one.
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Article IDs Section -->
                        <div class="modern-section-card">
                            <div class="section-card-header">
                                <div class="header-content">
                                    <i class="bi bi-tags-fill header-icon"></i>
                                    <h6 class="header-title">Associated Article IDs</h6>
                                </div>
                            </div>
                            <div class="section-card-body">
                                <div class="form-group-modern">
                                    <label class="form-label-modern">
                                        <i class="bi bi-tag"></i>
                                        Article IDs (comma-separated)
                                    </label>
                                    <input type="text" class="form-control-modern" 
                                        [ngModel]="currentPolyline.articleIds.join(', ')"
                                        (ngModelChange)="updatePolylineArticleIds($event)"
                                        placeholder="Enter article IDs separated by commas">
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button class="btn btn-secondary" (click)="closePolylineModal()">Cancel</button>
                    <button class="btn btn-primary" (click)="savePolyline()">Save Polyline</button>
                </div>
            </div>
        </div>
    </div>
    <!-- Modal backdrop -->
    <div class="modal-backdrop fade" [class.show]="showPolylineModal" *ngIf="showPolylineModal"></div>
